const isBrowser = typeof window !== 'undefined';
const host = isBrowser ? window.location.hostname : '';

const getUatApiUrl = (): string => {
  if (host.includes('sslip.io')) {
    return 'https://uat-api.72.62.254.61.sslip.io/api';
  }
  return 'https://uat-api-alltotrips.kchholding.tech/api';
};

export const environment = {
  name: 'uat',
  production: false,
  apiUrl: getUatApiUrl(),
} as const;
